export default __webpack_public_path__ + "static/media/agency1.195fb276.png";